import React from "react";

const NoDataComponent = () => {
  return (
    <div className="flex justify-center items-center h-[200px] flex-col ">
      <p>No Data found </p>
    </div>
  );
};

export default NoDataComponent;
